export const ensureProtocol = (url) => {
	const urlProtocolRegExp = /^[^:]+(?=:\/\/)/;
	let newUrl = url;

	if (!urlProtocolRegExp.test(newUrl)) {
		newUrl = `http://${newUrl}`;
	}

	return newUrl;
};

export const getHostname = (url) => {
	const domainRegex = /(?:https?:\/\/)?(?:[^@\u002F\n]+@)?(?:www\.)?([^:\u002F\n]+)/im;
	const matches = url.match(domainRegex);

	return (matches && matches.length) > 0 ? matches[1] : '';
};
